// @module Tavanoteam.CustomerFeedbackSurvey.CustomerFeedbackSurvey.Confirmation
define('Tavanoteam.CustomerFeedbackSurvey.CustomerFeedbackSurvey.Confirmation.View'
,	[
	'tavanoteam_customerfeedbacksurvey_customerfeedbacksurvey_confirmation.tpl'
	
	,	'Backbone'
	,	'Utils'
	,	'jQuery'
	,	'underscore'	
    ]
, function (
	tavanoteam_customerfeedbacksurvey_customerfeedbacksurvey_confirmation_tpl
	
	,	Backbone
	,	Utils
	,	jQuery
	,	_
)
{
    'use strict';

	// @class Tavanoteam.CustomerFeedbackSurvey.CustomerFeedbackSurvey.Confirmation.View @extends Backbone.View
	return Backbone.View.extend({

		template: tavanoteam_customerfeedbacksurvey_customerfeedbacksurvey_confirmation_tpl

    	// @property {String} title
    ,	title: Utils.translate('Feedback')

    	// @property {String} page_header
    ,	page_header: Utils.translate('Feedback')

	,	initialize: function (options) {

			Backbone.View.prototype.initialize.apply(this, arguments);

			var self = this;
	
			// Get Components
			this.container = options.container;
			this.layout = this.container.getComponent('Layout');
			this.environment = this.container.getComponent('Environment');

			// Get Configuration
			this.confirmationHeading = this.environment.getConfig('TTCustomerFeedbackSurvey.confirmationHeading');
			this.confirmationMessage = this.environment.getConfig('TTCustomerFeedbackSurvey.confirmationMessage');
		}

		//@method getContext @return Tavanoteam.CustomerFeedbackSurvey.CustomerFeedbackSurvey.Confirmation.View.Context
	,	getContext: function getContext()
		{
			//@class Tavanoteam.CustomerFeedbackSurvey.CustomerFeedbackSurvey.Confirmation.View.Context

			return {
					confirmationHeading: this.confirmationHeading
				,	confirmationMessage: this.confirmationMessage
			};
		}
	});
});
